import { Sidebar } from "@/components/sidebar/Sidebar";

interface NavbarProps {
  onLoadHistory?: (sessionId: number) => void;
  onClearMessages?: () => void;
  onNavigate?: (path: string) => void;
}

export const Navbar = ({ onLoadHistory, onClearMessages, onNavigate }: NavbarProps) => {
  return (
    <div className="bg-background absolute top-0 left-0 w-dvw py-2 px-3 justify-between flex flex-row items-center z-30">
      <div className="flex flex-row gap-3 items-center">
        <div className="flex flex-row gap-2 items-center">
          <div className="text-sm text-foreground font-bold truncate md:w-fit">
            <Sidebar
              onLoadHistory={onLoadHistory}
              onClearMessages={onClearMessages}
              mode="mobile"
              onNavigate={onNavigate}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
